module.exports = __webpack_public_path__ + "img/jt01.bdc9010a.png";